import { render } from "./TrasladobodeganView.vue?vue&type=template&id=783c02ff"
import script from "./TrasladobodeganView.vue?vue&type=script&lang=js"
export * from "./TrasladobodeganView.vue?vue&type=script&lang=js"

import "./TrasladobodeganView.vue?vue&type=style&index=0&id=783c02ff&lang=css"

import exportComponent from "D:\\gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__